import script from "./NewBannerindex.vue?vue&type=script&setup=true&lang=js"
export * from "./NewBannerindex.vue?vue&type=script&setup=true&lang=js"

import "./NewBannerindex.vue?vue&type=style&index=0&id=42e61176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e61176"]])

export default __exports__